module.exports = __webpack_public_path__ + "static/media/spiked_club.a7df74b7.png";